// extracted by mini-css-extract-plugin
export default {"panel":"MobilePanel_panel__6HhEW","open":"MobilePanel_open__QnIg-","autoscroll":"MobilePanel_autoscroll__2Yuvz","body":"MobilePanel_body__Ls+sr","footer":"MobilePanel_footer__aRIdA"};